import { render, staticRenderFns } from "./apply-record.vue?vue&type=template&id=a562f2cc&scoped=true";
import script from "./apply-record.vue?vue&type=script&lang=js";
export * from "./apply-record.vue?vue&type=script&lang=js";
import style0 from "./apply-record.vue?vue&type=style&index=0&id=a562f2cc&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "a562f2cc", null);
export default component.exports;